import Message from '@sats-group/ui-lib/react/message';
import React from 'react';
import ContentContainer from '~/client/components/content-container/content-container';
import PreviewLayout from '~/client/components/preview-layout/preview-layout';
import VideoBlock from '~/client/components/video-block/video-block';
import type { VideoBlockPreview as Props } from './video-block-preview.types';

const VideoBlockPreview: React.FC<Props> = ({ videoBlock }) => (
  <PreviewLayout>
    <div className="video-block-preview">
      <ContentContainer>
        {videoBlock ? (
          <VideoBlock {...videoBlock} />
        ) : (
          <Message text="No video block props" />
        )}
      </ContentContainer>
    </div>
  </PreviewLayout>
);

export default VideoBlockPreview;
